<template>
    <b-modal v-model="success" ref="success-modal" @hide="returnHome" hide-footer :title="$t('SUCCESS')">
        <!--<div slot="modal-title">{{$t('SUCCESS')}}</div>-->
        <b-container>
            <b-row>
                <b-col cols="10"
                       class="align-left">
                    {{message}}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="9">
                </b-col>
                <b-col cols="3">
                    <b-button class="btn btn-primary btn-lg btn-margin-narrow-aligned-right float-right make-space-above"
                              :title="$t('CLOSE')"
                              aria-label="Return"
                              @click="returnHome">
                        {{$t('CLOSE')}}
                    </b-button>
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>

<script>
    export default {
        name: 'Success',
        props: ['success', 'message', 'returnHome']

    }

</script>

